import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import OperatingYearRow from '@Router/NatureOfBusiness/Components/IncomeStructure/OperatingYearRow';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { getBuddhistYear } from '@Utils/datetime';
import { useIncomeStructure } from '../IncomeStructureProvider/IncomeStructureProvider';
import { OTHER_INCOME_TYPE_ID } from 'src/Enum/IncomeStructure';
import { findMasterDataById } from '../utils';
import OtherIncomeYearFieldsForm from './OtherIncomeYearFieldsForm';

const ShareProfitIncomeForm = () => {
  const { progressData } = useProgressBar();
  const { otherIncome } = useIncomeStructure();

  const startOperatingYear =
    progressData?.report.startOperatingYear ?? getBuddhistYear();

  const shareProfitIncome = findMasterDataById(
    otherIncome,
    OTHER_INCOME_TYPE_ID.SHARE_PROFIT
  );

  return (
    <Box mt={2}>
      <OperatingYearRow startOperatingYear={startOperatingYear} gap={1} />
      {shareProfitIncome && (
        <Flex width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350}>
            <InputLabel sx={{ textAlign: 'right', fontWeight: 800 }}>
              {shareProfitIncome.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (พันบาท)
            </Typography>
          </Box>
          <OtherIncomeYearFieldsForm
            keyItem={shareProfitIncome.id.toString()}
          />
        </Flex>
      )}
    </Box>
  );
};

export default ShareProfitIncomeForm;
